<template>
  <div class="navigationPage">
    <div class="topbox">
      <div class="topnav">
        <div class="left">
          <div class="logoArea">
            <a href="/">
              <img v-if="getLogo()" alt="logo" class="header-logo" :src="getLogo()" :title="webSystemSetting.webSiteName" />
            </a>
            <div class="slogo" @click="toHome">
              {{ webSystemSetting.webSiteName }}
            </div>
          </div>
          <ul class="nav">
            <li class="nav-li" @click="handleClick(item.url)" v-for="(item, index) in menus" :key="index">
              <router-link :to="item.url" :class="{ currentPage: isCurrentPage(item.url) }">{{ item.title }}</router-link>
              <!-- <a href="javascript:void(0)" :class="{ currentPage: true }" @click="">{{ item.title }}</a> -->
            </li>
          </ul>
        </div>
        <div v-show="isLogin" class="right">
          <div class="userName">{{ currentRegisterUser?.userName || currentRegisterUser?.contactNumber }}</div>
          <div class="handleNewsNav" @click="handleNewsNavClick">
            <div class="handleNewsNav-con">
              <div class="imgDiv"><img src="@/assets/images/xiaoxi.png" /></div>
            </div>
          </div>
          <a-dropdown placement="bottom">
            <a-badge>
              <a class="dropdown-wrap" @click.prevent>
                <img v-if="currentRegisterUser.gender == 0" class="avatarImg" src="@/assets/images/male.png" />
                <img v-else-if="currentRegisterUser.gender == 1" class="avatarImg" src="@/assets/images/female.png" />
                <img v-else class="avatarImg" src="@/assets/images/avatar_placeholder.png" />
              </a>
            </a-badge>
            <template #overlay>
              <a-menu>
                <a-menu-item>
                  <a-button type="link" @click="toAuthentication">实名信息 </a-button>
                </a-menu-item>
                <a-menu-item>
                  <a-button type="link" @click="changePhone">换绑手机 </a-button>
                </a-menu-item>
                <a-menu-item>
                  <a-button type="link" @click="modifyPassword">修改密码</a-button>
                </a-menu-item>
                <a-menu-item>
                  <a-button type="link" @click="handleLogOut">退出登录</a-button>
                </a-menu-item>
              </a-menu>
            </template>
          </a-dropdown>
        </div>
        <div v-show="!isLogin" class="right">
          <div class="noLoginWrap">
            <span v-if="webSystemSetting?.isAllowLogin" class="tipTxt" @click="toLogin">登录 / 注册</span>
            <span v-if="webSystemSetting?.isAllowLogin" class="avatar" @click="toLogin"><img src="@/assets/images/avatar_placeholder.png" /></span>
          </div>
        </div>
      </div>
    </div>

    <!-- 换绑手机 -->
    <ChangePhone v-if="showChangePhone" v-model:open="showChangePhone" />

    <!-- 修改登录密码 -->
    <ChangePassword v-if="showChangePassword" v-model:open="showChangePassword" :closable="closableChangePassword" />
  </div>
</template>

<script lang="ts">
import { defineComponent, reactive, onMounted, toRefs, watch, computed } from "vue";
import { useRoute } from "vue-router";
import ChangePhone from "./changePhone.vue";
import ChangePassword from "./changePassword.vue";
import { store } from "@/store";
import { MinioToolsClass } from "@/utils/minioToolsClass";
import router from "@/router";
import { doLogin, doLogout } from "@/utils/oidcServer";
export default defineComponent({
  name: "Navigation",
  components: { ChangePhone, ChangePassword },
  setup() {
    onMounted(() => {});

    const isLogin = computed(() => store.state.isLogin);

    const menus = computed(() => (store.state.isLogin ? state.navList : state.navList.filter((menu: any) => menu.needLogin === false)));

    const route = useRoute();

    const state = reactive({
      currentRegisterUser: store.state.currentRegisterUser || {},
      webSystemSetting: store.state.webSystemSetting,
      showChangePhone: false,
      showChangePassword: false,
      closableChangePassword: true,
      userName: "",
      gender: null as any,
      visible_tel: false,
      loading_button: false,
      current: 0,
      unreadCount: 0,
      navList: [
        {
          title: "我的报名",
          name: "exam",
          url: "/exam/list",
          needLogin: true,
        },
        {
          title: "当前考试",
          name: "currentExam",
          url: "/current/exams",
          needLogin: false,
        },
        {
          title: "个人信息",
          name: "personalinformation",
          url: "/userCenter/personal",
          needLogin: true,
        },
        {
          title: "公告",
          name: "noticeList",
          url: "/notice/list",
          needLogin: false,
        },
      ] as any[],
    });
    const event = {
      getLogo() {
        return MinioToolsClass.getMinioFileCompleteUrl(state.webSystemSetting.logo);
      },
      // 初始化页面
      initPage: async () => {
        if (isLogin) {
          // event.isChangePassword();
        } else {
          // 未登录：获取未登录菜单
          event.getLoginOutMenu();
        }
      },
      // 去登录
      toLogin() {
        doLogin();
      },
      // 获取未登录菜单：菜单导航显示“当前考试”和“公告”两个栏目
      getLoginOutMenu() {
        state.navList = state.navList.filter((menu: any) => menu.name == "currentExam" || menu.name == "noticeList");
      },
      isCurrentPage: (params: any) => {
        return route.path == params;
      },
      handleClick: (params: any) => router.push(params),
      handleLogOut() {
        // router.replace({ name: "logout" });
        // doLogout({ extraQueryParams: { client_id: import.meta.env.VITE_OIDC_CLIENT_ID } });
        doLogout();
      },
      handleNewsNavClick() {
        const userInfo = store.state.currentRegisterUser;
        console.log({ userInfo });
        router.push({ name: "newslist" });
      },
      modifyPassword() {
        const newHref = `${import.meta.env.VITE_OIDC_AUTHORITY}/modifyPassword?callback=${encodeURIComponent(window.location.origin)}`;
        window.location.href = newHref;
        // router.push({ name: "modifyPassword" });
      },
      changePhone() {
        const newHref = `${import.meta.env.VITE_OIDC_AUTHORITY}/changePhone?callback=${encodeURIComponent(window.location.origin)}`;
        window.location.href = newHref;
        // router.push({ name: "changePhone" });
      },
      toAuthentication() {
        router.push({ name: "authentication" });
      },
      toHome() {
        router.push({ path: "/" });
      },
    };
    watch(
      () => store.state.message.unreadCount,
      () => {
        state.unreadCount = store.state.message.unreadCount;
      },
      { deep: true, immediate: false },
    );
    return {
      ...toRefs(state),
      ...event,
      isLogin,
      menus,
    };
  },
});
</script>

<style lang="less" scoped>
.navigationPage {
  background: #0099ff;
  height: 85px;
  line-height: 56px;
  .topbox {
    width: 1100px;
    margin: 0 auto;
    .topnav {
      height: 85px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .left {
        display: flex;
        flex: 1;
        .logoArea {
          display: flex;
          align-items: center;
          margin-right: 50px;
          cursor: pointer;
          overflow: hidden;
          .header-logo {
            width: auto;
            max-height: 48px;
            margin-right: 20px;
          }
          .slogo {
            color: #fff;
            font-family:
              //* 苹果系统首选字体 */
              "PingFang SC",
              //* 微软雅黑兼容方案 */
              "Microsoft YaHei",
              "Source Han Serif SC",
              "Source Han Serif SC-Heavy",
              //* 苹果旧版系统字体 */
              "Helvetica Neue",
              //* 苹果最新系统字体 */
              "San Francisco",
              //* 通用无衬线字体降级 */
              sans-serif;
            font-weight: 700;
            font-size: 24px;
            line-height: 1.2;
            letter-spacing: 1px;
            // white-space: nowrap;
          }
        }
        .nav {
          display: flex;
          li {
            color: #fff;
            display: flex;
            font-weight: bold;
            font-size: 17px;
            a {
              color: rgba(255, 255, 255, 0.75);
              white-space: nowrap;
              text-decoration: none;
              margin: 0 20px;
              display: flex;
              align-items: center;
              &.currentPage {
                color: #fff;
                text-decoration: none;
                position: relative;
                &:after {
                  content: "";
                  position: absolute;
                  bottom: 5px;
                  left: 0;
                  width: 100%;
                  height: 3px;
                  background-color: #fff;
                }
              }
            }
          }
        }

        .Highlight {
          position: relative;
          height: 40px;
        }
        .Highlight a {
          display: block;
        }
        .Highlight a:before {
          position: absolute;
          bottom: 0;
          left: 5%;
          z-index: 100;
          width: 90%;
          height: 3px;
          content: "";
          background-color: #fff;
          border-radius: 5px;
        }
      }
      .right {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        .userName {
          color: #fff;
          margin-left: 10px;
          font-size: 14px;
          white-space: nowrap;
        }
        .noLoginWrap {
          display: flex;
          align-items: center;
          font-size: 14px;
          .tipTxt {
            color: #fff;
            cursor: pointer;
          }
          .line {
            color: rgba(255, 255, 255, 0.5);
            margin: 0 8px;
          }
          .avatar {
            margin-left: 10px;
            img {
              width: 35px;
              height: 35px;
              border-radius: 50%;
            }
          }
        }
        .handleNewsNav {
          display: flex;
          align-items: center;
          margin: 0 5px;
          .handleNewsNav-con {
            position: relative;
            cursor: pointer;
            margin: 0 10px;
            .imgDiv {
              display: flex;
              align-items: center;
            }
            .badgeDiv {
              position: absolute;
              z-index: 99;
              display: flex;
              align-items: center;
              right: -8px;
              top: -8px;
            }
          }
        }
        .dropdown-wrap {
          .avatarImg {
            width: 35px;
            height: 35px;
            border-radius: 50px;
            border: 1px solid #fff;
            background: #fff;
          }
        }
      }
    }
  }
}
</style>
